import { AbstractControl, ValidationErrors } from "@angular/forms";

export const postalCodeValidator = (control: AbstractControl): ValidationErrors | null => {
  const postalCode = control.value;
  return /^[1-9][0-9]{3} ?(?!SA|SD|SS)[A-Z]{2}$/i.test(postalCode) ? null : { postalCode };
};
